import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';

import { detectVersion, whiteCookie } from '@/services/detectBrowser';

import { EXPIRE_TIME_KEY } from '../utils/constants';
import XSensors from '../utils/skynet';

export function useCheckBrowser() {
  const [browserTipModalVisible, setBrowserTipModalVisible] = useState(false);

  const detectBrowserVersion = async () => {
    const isSuccess = await whiteCookie();
    if (isSuccess) {
      const isSupport = await detectVersion();
      console.info(
        isSupport,
        EXPIRE_TIME_KEY,
        Cookie.get(EXPIRE_TIME_KEY) &&
          Number(Cookie.get(EXPIRE_TIME_KEY)) - +new Date() > 0,
        'isSupport',
      );
      setBrowserTipModalVisible(!isSupport);
      XSensors.track('detectBrowser', {
        is_support: !!isSupport,
      });
    }
  };

  useEffect(() => {
    try {
      if (
        Cookie.get(EXPIRE_TIME_KEY) &&
        Number(Cookie.get(EXPIRE_TIME_KEY)) - +new Date() > 0
      ) {
        setBrowserTipModalVisible(false);
      } else {
        detectBrowserVersion();
      }
    } catch (e) {
      console.error(e);
    }
  }, []);
  const closeBrowserTipModalVisible = () => {
    setBrowserTipModalVisible(false);
  };
  return { browserTipModalVisible, closeBrowserTipModalVisible };
}
